<template>
  <transition name="fade">
    <div class="pattern-modal" v-if="visible" style="z-index:999;">
      <div class="pattern-modal-holder" v-on-clickaway="hideModal">
          <div class="pattern-modal-content">
            <h1>{{title}}</h1>
            <main>{{text}}</main>
            <button v-if="closeable" @click="hideModal">
                {{ $t('modal.close')}}
            </button>
          </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {directive as onClickaway} from 'vue-clickaway';
import { EventBus } from '../event-bus.js';

export default {
  directives: {
    onClickaway: onClickaway,
  },
  name: 'popup',
  data() {
    return {
      visible: false,
      title:'',
      text:'',
      closeable:false,
      type:'',
    }
  },
  created(){
    EventBus.$on('openInfoModal', this.showModal)
  },
  beforeDestroy() {
    this.$off('openInfoModal')
  },
  methods:{
    hideModal(){
      if(this.closeable) {
        this.visible = false;
        this.closeable = false;
      }
    },
    showModal(data){
      if(data.title){
        this.title = data.title;
      }
      if(data.closeable){
        this.closeable = data.closeable;
      }
      if(data.text){
        this.text = data.text;
      }
      if(data.type){
        this.type = data.type
      }
      this.visible = true;
    }
  }
}
</script>

<style>

.pattern-modal {
  @apply overflow-hidden text-base fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-400 z-50 bg-opacity-50
}

.pattern-modal-content {
  @apply fixed  p-0 left-0 right-0 w-screen h-screen md:sticky p-4 lg:p-8  md:rounded relative bg-white  md:w-auto md:h-auto md:shadow-lg;

  &  h1 {
    @apply text-lg text-gray-700
  }

  &  main {
  @apply max-w-xl   text-gray-500
  }

  &  button {
  @apply outline-none w-full leading-none mt-4 text-base  rounded shadow mr-2.5 px-3 py-2.5 rounded text-white bg-primary;
  }
}

</style>